import type { ContractCount } from "@/modules/companies/client/components/RecruitmentPatternInformation/utils/analyticsUtils"
import type { CSSProperties, FunctionComponent } from "react"

import { useLocale } from "@/modules/locales/useLocale"

import styles from "./Column.module.css"

type ColumnsProps = {
  maxValue: number
  data: ContractCount
  date: Date
}
export const Column: FunctionComponent<ColumnsProps> = props => {
  const { maxValue, data, date } = props
  const locale = useLocale()

  const localeFormatterShort = new Intl.DateTimeFormat(locale, { month: "short" })
  const localeFormatterLong = new Intl.DateTimeFormat(locale, { month: "long" })

  return (
    <li className={styles.wrapper}>
      <div className={styles.legend}>
        <time dateTime={date.toISOString()} aria-hidden>
          {localeFormatterShort.format(date)}
        </time>
        <time dateTime={date.toISOString()} className="sr-only">
          {localeFormatterLong.format(date)}
        </time>
        <span className="sr-only"> : </span>
      </div>
      <div className={styles.columns}>
        {Object.entries(data).map((position, index) => {
          const [columnName, columnValue] = position
          return (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className={styles.column}
              style={
                {
                  "--columnHeight": `${(columnValue / maxValue) * 100}%`,
                } as CSSProperties
              }
            >
              <span className="sr-only">{columnName} </span>
            </div>
          )
        })}
      </div>
    </li>
  )
}
